// extracted by mini-css-extract-plugin
export var container = "_av-0";
export var containerTopRight = "_av-1";